// <editor-fold desc="Action Types">

/**
 * Action types
 */
export enum ActionTypes {
  /**
   * Store
   */
  Reset = '[STORE | AUTHOR | BULK_EDIT] Reset',
  ResetSelection = '[STORE | AUTHOR | BULK_EDIT] Reset Selection',
  
  ToggleMedia = '[STORE | AUTHOR | BULK_EDIT] Toggle Media',
  SetMedias = '[STORE | AUTHOR | BULK_EDIT] Set Medias',
  RemoveMedia = '[STORE | AUTHOR | BULK_EDIT] Remove Media',
  RemoveMedias = '[STORE | AUTHOR | BULK_EDIT] Remove Medias',
  
  ToggleNode = '[STORE | AUTHOR | BULK_EDIT] Toggle Node',
  SetNodes = '[STORE | AUTHOR | BULK_EDIT] Set Nodes',
  CopyNodes = '[STORE | AUTHOR | BULK_EDIT] Copy Nodes',
  RemoveNode = '[STORE | AUTHOR | BULK_EDIT] Remove Node',
  RemoveNodes = '[STORE | AUTHOR | BULK_EDIT] Remove Nodes',
  
  TogglePage = '[STORE | AUTHOR | BULK_EDIT] Toggle Page',
  SetPages = '[STORE | AUTHOR | BULK_EDIT] Set Pages',
  CopyPages = '[STORE | AUTHOR | BULK_EDIT] Copy Pages',
  SetCopyPages = '[STORE | AUTHOR | BULK_EDIT] Set Copy Pages',
  RemovePage = '[STORE | AUTHOR | BULK_EDIT] Remove Page',
  RemovePages = '[STORE | AUTHOR | BULK_EDIT] Remove Pages',
  
  ToggleLayer = '[STORE | AUTHOR | BULK_EDIT] Toggle Layer',
  SetLayers = '[STORE | AUTHOR | BULK_EDIT] Set Layers',
  CopyLayers = '[STORE | AUTHOR | BULK_EDIT] Copy Layers',
  RemoveLayer = '[STORE | AUTHOR | BULK_EDIT] Remove Layer',
  RemoveLayers = '[STORE | AUTHOR | BULK_EDIT] Remove Layers',
  
  ToggleImage = '[STORE | AUTHOR | BULK_EDIT] Toggle Image',
  SetImages = '[STORE | AUTHOR | BULK_EDIT] Set Images',
  CopyImages = '[STORE | AUTHOR | BULK_EDIT] Copy Images',
  RemoveImage = '[STORE | AUTHOR | BULK_EDIT] Remove Image',
  RemoveImages = '[STORE | AUTHOR | BULK_EDIT] Remove Images',
  
  ToggleGroup = '[STORE | AUTHOR | BULK_EDIT] Toggle Group',
  SetGroups = '[STORE | AUTHOR | BULK_EDIT] Set Groups',
  CopyGroups = '[STORE | AUTHOR | BULK_EDIT] Copy Groups',
  RemoveGroup = '[STORE | AUTHOR | BULK_EDIT] Remove Group',
  RemoveGroups = '[STORE | AUTHOR | BULK_EDIT] Remove Groups',
  
  ToggleAnnotation = '[STORE | AUTHOR | BULK_EDIT] Toggle Annotation',
  SetAnnotations = '[STORE | AUTHOR | BULK_EDIT] Set Annotations',
  CopyAnnotations = '[STORE | AUTHOR | BULK_EDIT] Copy Annotations',
  RemoveAnnotation = '[STORE | AUTHOR | BULK_EDIT] Remove Annotation',
  RemoveAnnotations = '[STORE | AUTHOR | BULK_EDIT] Remove Annotations',
  
  ToggleQuestion = '[STORE | AUTHOR | BULK_EDIT] Toggle Question',
  SetQuestions = '[STORE | AUTHOR | BULK_EDIT] Set Questions',
  CopyQuestions = '[STORE | AUTHOR | BULK_EDIT] Copy Questions',
  RemoveQuestion = '[STORE | AUTHOR | BULK_EDIT] Remove Question',
  RemoveQuestions = '[STORE | AUTHOR | BULK_EDIT] Remove Questions',
  
  ToggleChoice = '[STORE | AUTHOR | BULK_EDIT] Toggle Choice',
  SetChoices = '[STORE | AUTHOR | BULK_EDIT] Set Choices',
  CopyChoices = '[STORE | AUTHOR | BULK_EDIT] Copy Choices',
  RemoveChoice = '[STORE | AUTHOR | BULK_EDIT] Remove Choice',
  RemoveChoices = '[STORE | AUTHOR | BULK_EDIT] Remove Choices',
  
  TogglePoi = '[STORE | AUTHOR | BULK_EDIT] Toggle Poi',
  SetPois = '[STORE | AUTHOR | BULK_EDIT] Set Pois',
  CopyPois = '[STORE | AUTHOR | BULK_EDIT] Copy Pois',
  RemovePoi = '[STORE | AUTHOR | BULK_EDIT] Remove Poi',
  RemovePois = '[STORE | AUTHOR | BULK_EDIT] Remove Pois',
  /**
   * Request
   */
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Reset
 */
export class Reset {
  public static readonly type = ActionTypes.Reset;
}

/**
 * Reset Selection
 */
export class ResetSelection {
  public static readonly type = ActionTypes.ResetSelection;
}

//<editor-fold desc="Media">

/**
 * Toggle Media
 */
export class ToggleMedia {
  public static readonly type = ActionTypes.ToggleMedia;
  
  public constructor(public id: string) {
  }
}

/**
 * Set Medias
 */
export class SetMedias {
  public static readonly type = ActionTypes.SetMedias;
  
  public constructor(public ids: string[]) {
  }
}

/**
 * Remove Media
 */
export class RemoveMedia {
  public static readonly type = ActionTypes.RemoveMedia;
  
  public constructor(public id: string) {
  }
}

/**
 * Remove Medias
 */
export class RemoveMedias {
  public static readonly type = ActionTypes.RemoveMedias;
  
  public constructor(public ids: string[]) {
  }
}

//</editor-fold>

//<editor-fold desc="Node">

/**
 * Toggle Node
 */
export class ToggleNode {
  public static readonly type = ActionTypes.ToggleNode;
  
  public constructor(public id: string,
                     public parentId: string | null) {
  }
}

/**
 * Set Nodes
 */
export class SetNodes {
  public static readonly type = ActionTypes.SetNodes;
  
  public constructor(public ids: string[]) {
  }
}

/**
 * Copy Nodes
 */
export class CopyNodes {
  public static readonly type = ActionTypes.CopyNodes;
  
  public constructor(public selectNodeSet: Set<string>) {
  }
}

/**
 * Remove Node
 */
export class RemoveNode {
  public static readonly type = ActionTypes.RemoveNode;
  
  public constructor(public id: string) {
  }
}

/**
 * Remove Nodes
 */
export class RemoveNodes {
  public static readonly type = ActionTypes.RemoveNodes;
  
  public constructor(public ids: string[]) {
  }
}

//</editor-fold>

//<editor-fold desc="Page">

/**
 * Toggle Page
 */
export class TogglePage {
  public static readonly type = ActionTypes.TogglePage;
  
  public constructor(public id: string) {
  }
}

/**
 * Set Pages
 */
export class SetPages {
  public static readonly type = ActionTypes.SetPages;
  
  public constructor(public ids: string[]) {
  }
}

/**
 * Copy Pages
 */
export class CopyPages {
  public static readonly type = ActionTypes.CopyPages;
  
  public constructor(public selectPageSet: Set<string>) {
  }
}

/**
 * Set Copy Pages
 */
export class SetCopyPages {
  public static readonly type = ActionTypes.SetCopyPages;
  
  public constructor(public copyPageSet: Set<string>) {
  }
}

/**
 * Remove Page
 */
export class RemovePage {
  public static readonly type = ActionTypes.RemovePage;
  
  public constructor(public id: string) {
  }
}

/**
 * Remove Pages
 */
export class RemovePages {
  public static readonly type = ActionTypes.RemovePages;
  
  public constructor(public ids: string[]) {
  }
}

//</editor-fold>

//<editor-fold desc="Layer">

/**
 * Toggle Layer
 */
export class ToggleLayer {
  public static readonly type = ActionTypes.ToggleLayer;
  
  public constructor(public id: string) {
  }
}

/**
 * Set Layers
 */
export class SetLayers {
  public static readonly type = ActionTypes.SetLayers;
  
  public constructor(public ids: string[]) {
  }
}

/**
 * Copy Layers
 */
export class CopyLayers {
  public static readonly type = ActionTypes.CopyLayers;
  
  public constructor(public selectLayerSet: Set<string>) {
  }
}

/**
 * Remove Layer
 */
export class RemoveLayer {
  public static readonly type = ActionTypes.RemoveLayer;
  
  public constructor(public id: string) {
  }
}

/**
 * Remove Layers
 */
export class RemoveLayers {
  public static readonly type = ActionTypes.RemoveLayers;
  
  public constructor(public ids: string[]) {
  }
}

//</editor-fold>

//<editor-fold desc="Image">

/**
 * Toggle Image
 */
export class ToggleImage {
  public static readonly type = ActionTypes.ToggleImage;
  
  public constructor(public id: string) {
  }
}

/**
 * Set Images
 */
export class SetImages {
  public static readonly type = ActionTypes.SetImages;
  
  public constructor(public ids: string[]) {
  }
}

/**
 * Copy Images
 */
export class CopyImages {
  public static readonly type = ActionTypes.CopyImages;
  
  public constructor(public selectImageSet: Set<string>) {
  }
}

/**
 * Remove Image
 */
export class RemoveImage {
  public static readonly type = ActionTypes.RemoveImage;
  
  public constructor(public id: string) {
  }
}

/**
 * Remove Images
 */
export class RemoveImages {
  public static readonly type = ActionTypes.RemoveImages;
  
  public constructor(public ids: string[]) {
  }
}

//</editor-fold>

//<editor-fold desc="Group">

/**
 * Toggle Group
 */
export class ToggleGroup {
  public static readonly type = ActionTypes.ToggleGroup;
  
  public constructor(public id: string) {
  }
}

/**
 * Set Groups
 */
export class SetGroups {
  public static readonly type = ActionTypes.SetGroups;
  
  public constructor(public ids: string[]) {
  }
}

/**
 * Copy Groups
 */
export class CopyGroups {
  public static readonly type = ActionTypes.CopyGroups;
  
  public constructor(public selectGroupSet: Set<string>) {
  }
}

/**
 * Remove Group
 */
export class RemoveGroup {
  public static readonly type = ActionTypes.RemoveGroup;
  
  public constructor(public id: string) {
  }
}


/**
 * Remove Groups
 */
export class RemoveGroups {
  public static readonly type = ActionTypes.RemoveGroups;
  
  public constructor(public ids: string[]) {
  }
}

//</editor-fold>

//<editor-fold desc="Annotation">

/**
 * Toggle Annotation
 */
export class ToggleAnnotation {
  public static readonly type = ActionTypes.ToggleAnnotation;
  
  public constructor(public id: string) {
  }
}

/**
 * Set Annotations
 */
export class SetAnnotations {
  public static readonly type = ActionTypes.SetAnnotations;
  
  public constructor(public ids: string[]) {
  }
}

/**
 * Copy Annotations
 */
export class CopyAnnotations {
  public static readonly type = ActionTypes.CopyAnnotations;
  
  public constructor(public selectAnnotationSet: Set<string>) {
  }
}

/**
 * Remove Annotation
 */
export class RemoveAnnotation {
  public static readonly type = ActionTypes.RemoveAnnotation;
  
  public constructor(public id: string) {
  }
}

/**
 * Remove Annotations
 */
export class RemoveAnnotations {
  public static readonly type = ActionTypes.RemoveAnnotations;
  
  public constructor(public ids: string[]) {
  }
}

//</editor-fold>

//<editor-fold desc="Question">

/**
 * Toggle Question
 */
export class ToggleQuestion {
	public static readonly type = ActionTypes.ToggleQuestion;
	
	public constructor(public id: string) {
	}
}

/**
 * Set Questions
 */
export class SetQuestions {
	public static readonly type = ActionTypes.SetQuestions;
	
	public constructor(public ids: string[]) {
	}
}

/**
 * Copy Questions
 */
export class CopyQuestions {
	public static readonly type = ActionTypes.CopyQuestions;
  
  public constructor(public selectQuestionSet: Set<string>) {
  }
}

/**
 * Remove Question
 */
export class RemoveQuestion {
	public static readonly type = ActionTypes.RemoveQuestion;
	
	public constructor(public id: string) {
	}
}

/**
 * Remove Questions
 */
export class RemoveQuestions {
	public static readonly type = ActionTypes.RemoveQuestions;
	
	public constructor(public ids: string[]) {
	}
}

//</editor-fold>

//<editor-fold desc="Choice">

/**
 * Toggle Choice
 */
export class ToggleChoice {
  public static readonly type = ActionTypes.ToggleChoice;
  
  public constructor(public id: string) {
  }
}

/**
 * Set Choices
 */
export class SetChoices {
  public static readonly type = ActionTypes.SetChoices;
  
  public constructor(public ids: string[]) {
  }
}

/**
 * Copy Choices
 */
export class CopyChoices {
  public static readonly type = ActionTypes.CopyChoices;
  
  public constructor(public selectChoiceSet: Set<string>) {
  }
}

/**
 * Remove Choice
 */
export class RemoveChoice {
  public static readonly type = ActionTypes.RemoveChoice;
  
  public constructor(public id: string) {
  }
}

/**
 * Remove Choices
 */
export class RemoveChoices {
  public static readonly type = ActionTypes.RemoveChoices;
  
  public constructor(public ids: string[]) {
  }
}

//</editor-fold>

//<editor-fold desc="Poi">

/**
 * Toggle Poi
 */
export class TogglePoi {
  public static readonly type = ActionTypes.TogglePoi;
  
  public constructor(public id: string) {
  }
}

/**
 * Set Pois
 */
export class SetPois {
  public static readonly type = ActionTypes.SetPois;
  
  public constructor(public ids: string[]) {
  }
}

/**
 * Copy Pois
 */
export class CopyPois {
  public static readonly type = ActionTypes.CopyPois;
  
  public constructor(public selectPoiSet: Set<string>) {
  }
}

/**
 * Remove Poi
 */
export class RemovePoi {
  public static readonly type = ActionTypes.RemovePoi;
  
  public constructor(public id: string) {
  }
}

/**
 * Remove Pois
 */
export class RemovePois {
  public static readonly type = ActionTypes.RemovePois;
  
  public constructor(public ids: string[]) {
  }
}

//</editor-fold>

// </editor-fold>

// <editor-fold desc="Request">

// </editor-fold>
